import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Typeahead } from 'react-bootstrap-typeahead';
import ErrorIcon from '../../../assets/images/icon_error_messages.gif';
import Label from './common/label';
import { sortedObjects } from '../../utils/utils';
import request from '../../utils/request';

const Dealership = ({ labels, errors, touched, values, setFieldValue }) => {
  const [dealershipList, setDealershipList] = useState([]);

  useEffect(() => {
    request.get('/dealerships').then(({ data: { rows: dealershis } }) => {
      const updatesList = sortedObjects(dealershis, 'name').map(
        ({ name, id }) => {
          return { id, label: name };
        }
      );
      setDealershipList(updatesList);
    });
  }, []);

  return (
    <>
      <Label labelName={labels.DEALERSHIP_NAME} />
      <div
        style={{ position: 'relative', width: '100%', marginBottom: '-1.5rem' }}
        className={`frg-select-container color-light input-container ${
          errors.channel && touched.channel ? 'error' : ''
        }`}
      >
        <Typeahead
          id="channel"
          labelKey="label"
          options={dealershipList}
          onChange={e => {
            setFieldValue('dealership', e);
          }}
          placeholder="Select dealerhsip"
          selected={values.dealership || []}
          clearButton
        />
        <>
          <div className="error_messages">
            <span className="frg-body-font-14px">{errors.dealership}</span>
          </div>
          <div id="username_error_icon" className="error_messages_icon">
            <img src={ErrorIcon} alt="error_icon" />
          </div>
        </>
      </div>
    </>
  );
};

Dealership.propTypes = {
  labels: PropTypes.isRequired,
  errors: PropTypes.isRequired,
  touched: PropTypes.func.isRequired,
  values: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    password: PropTypes.string,
    channel: PropTypes.arrayOf(PropTypes.object),
    multiChannels: PropTypes.arrayOf(PropTypes.object),
    outlet: PropTypes.string,
    salesManager: PropTypes.string,
    salesManagerEmail: PropTypes.string,
    cpmsId: PropTypes.string,
    contactNumber: PropTypes.string,
    province: PropTypes.string,
    multiProvinces: PropTypes.arrayOf(PropTypes.object),
    recaptcha: PropTypes.string,
    channelOrgCode: PropTypes.string,
    dealership: PropTypes.arrayOf(PropTypes.object),
    xid: PropTypes.string
  }).isRequired,
  setFieldValue: PropTypes.func.isRequired
};

export default Dealership;
